import { useContext, useEffect } from "react";
import { ToolContext } from "../../../../context/ToolContext";
import { JoyrideWrapper } from "../JoyrideWrapper";

export const BranchProductWalkthrough = ({ pathname, end, start}) => {

    const {personalization_state} = useContext(ToolContext)
    const {walkthrough} = personalization_state

    const startTour = () =>{
        walkthrough.set((prev) => ({...prev, createBranchProduct:true}))
    }

    const endTour = ()=>{
        walkthrough.set((prev) => ({...prev, createBranchProduct:false}))
    }

    useEffect(() => {
        start("setup", "branch-product-setup", startTour)
        //eslint-disable-next-line
    }, []);

    const steps =[
            {
                content: "Select the branch you want to include the product",
                placement: "bottom",
                target: "#walkthrough-branch-product-step-1",
                disableBeacon: true
            },
            {
                content: "Select category of the product",
                placement: "right",
                target: "#walkthrough-branch-product-step-2",
                disableBeacon: true
            },
            {
                content: "Select sub-category of the product",
                placement: "right",
                target: "#walkthrough-branch-product-step-3",
                disableBeacon: true
            },
            {
                content: "Select the product",
                placement: "right",
                target: "#walkthrough-branch-product-step-4",
                disableBeacon: true
            },
            {
                content: "Add product quantity",
                placement: "right",
                target: "#walkthrough-branch-product-step-5",
                disableBeacon: true
            },
                        {
                content: "Add product price",
                placement: "right",
                target: "#walkthrough-branch-product-step-6",
                disableBeacon: true
            },
            {
                content: "Add discount (optional)",
                placement: "right",
                target: "#walkthrough-branch-product-step-7",
                disableBeacon: true
            },
            {
                content: "Add Alias Name (optional)",
                placement: "right",
                target: "#walkthrough-branch-product-step-8",
                disableBeacon: true
            },
            {
                content: "Drag and drop or select the image of your product",
                placement: "right",
                target: "#walkthrough-branch-product-step-9",
                disableBeacon: true
            },
            {
                content: "Toggle visible to show it as salable products",
                placement: "right",
                target: "#walkthrough-branch-product-step-10",
                disableBeacon: true
            },
                        {
                content: "Click this to add more product under the same branch",
                placement: "right",
                target: "#walkthrough-branch-product-step-11",
                disableBeacon: true
            },
            {
                content: "Click this to add more product with different branch",
                placement: "right",
                target: "#walkthrough-branch-product-step-12",
                disableBeacon: true
            },
            {
                content: "Click Save once done",
                placement: "right",
                target: "#walkthrough-branch-product-step-13",
                disableBeacon: true
            },
        ]

    return (
        <JoyrideWrapper 
            run={walkthrough.data.createBranchProduct && window.location.pathname === pathname} 
            steps={steps} 
            setter={endTour} 
            end={end}
            p_name="branch-product-setup" 
            featureName="setup"
        />
    );
}
